<template>
  <div class="layoutDefault">
    <travelNav :class="homeClass" :isWhite="$route && ($route.name === 'Home' || $route.name === 'Voucher')"/>
    <travelNav v-if="$route && ($route.name === 'Home' || $route.name === 'Voucher')" class="shadow" :style="homeStyle"/>
    <div class="sticky-body" :class="$route.name === 'Socket' && 'chat'">
      <slot></slot>
    </div>
    <travelFooter v-if="$route.name !== 'Socket'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import travelNav from '@/layouts/travelNav'
// import travelFooter from '@/layouts/travelFooter'

export default {
  name: 'layoutDefault',
  components: {
    travelNav,
    'travelFooter': () => import('@/layouts/travelFooter.vue')
  },
  computed: {
    ...mapGetters([
      'scrollTop'
    ]),
    homeClass: function () {
      let result = []
      if (this.$route.name === 'Home' || this.$route.name === 'Voucher') {
        result.push('isFixed')
        result.push('isTransparent')
        result.push('isWhite')
        if (this.scrollTop > 300) {
          result.push('invisible')
        }
      }
      return result.join(' ')
    },
    homeStyle: function () {
      let result = ['position: fixed; width: 100%; top: 0; left: 0;']
      if (this.scrollTop < 800) {
        result.push('transform: translateY(-100px);')
      }
      return result.join(' ')
    }
  }
}
</script>

<style lang="sass" scoped>
.layoutDefault
  @apply bg-white flex flex-col relative
  min-height: 100vh
  .sticky-body
    min-height: 100vh
    @apply flex-auto
    &.chat
      min-height: calc(100vh - 60px)
</style>
